import * as Styles from './styles';
import { useTranslation } from 'react-i18next';
import { AvatarWrapper,IconContentCopy} from 'cdk-radial';
import CopyLabel from './CopyLabel';
import { IconInfo } from 'cdk-radial';
import { withTooltip,THEMES } from 'cdk-radial';

const ComponentToRender = (props:any) => {
  return (
    <div style={{marginTop:'3px',marginLeft:'5px'}} >
      <IconInfo  height={18} width={18} style={{marginTop:'-5px'}} {...props}/>
    </div>
  );
};

export const generateTooltipProps = (displayName:string) => ( 
  {
    id:`meet-my-team-title-icon`,
    text:displayName, 
    theme:THEMES.LIGHT,
    styles:{ zIndex:1002, display: window.innerWidth < 501 && 'none' }} 
)
export const tooltipMessages  = [
  {key:"Account Sales Executive",value:"meetmycdkteam.ase-tooltip"},
  {key:"Account Manager",value:"meetmycdkteam.iam-tooltip"},
  {key:"Customer Success Manager",value:"meetmycdkteam.csm-tooltip"},
  {key:"Associate Account Sales Executive",value:"meetmycdkteam.aase-tooltip"},
]

export const TooltipTitle = (props:{title:string}) =>{
  const { t } = useTranslation();
  const key = tooltipMessages.find(tooltip => tooltip.key === props.title) as any;
  const TitleHelpIcon =  withTooltip(ComponentToRender, generateTooltipProps(t(key?.value)));
  return <TitleHelpIcon></TitleHelpIcon>;
}

export const Profile =({profile,isAdmin,isMyCdkTeamAccess}:any) =>{
    const {t} = useTranslation();
    const nameAbbr = (profile?.firstName || '').substring(0,1) + (profile?.lastName || '').substring(0,1);
  return (
      <Styles.ProfileContainer>
        <Styles.AvatarContainer>
            <AvatarWrapper label={profile.firstName +" "+profile.lastName}>
              <Styles.AvatarContent>{nameAbbr}</Styles.AvatarContent>
          </AvatarWrapper>
            <Styles.MarginLeftSpacing>
            <Styles.Name>{profile.firstName +" "+profile.lastName}</Styles.Name>
            <div style={{display:'flex'}}>
              <div>
              {profile.title}
              </div>
              {profile.title && <TooltipTitle title={profile.title}></TooltipTitle>}
            </div>
          </Styles.MarginLeftSpacing>
        </Styles.AvatarContainer>
          { (isAdmin || isMyCdkTeamAccess) &&
          <Styles.PhoneAndEmailContainer>
            <Styles.PhoneLabel >{t('profile.phone')}</Styles.PhoneLabel>
            {!profile.phoneNo && <div/>}
            {profile.phoneNo && <CopyLabel icon={<IconContentCopy/>} label={profile.phoneNo}/>}
            <Styles.EmailLabel >{t('profile.email')}</Styles.EmailLabel> 
            {!profile.email && <div/>}
            {profile.email && <CopyLabel icon={<IconContentCopy/>} label={profile.email}/> }
          </Styles.PhoneAndEmailContainer>
          }
          { !isAdmin && <Styles.NoPhoneAndEmailContainer/> }
      </Styles.ProfileContainer>
    )
}
